// Service cards configuration
export const useHomeData = () => {
  const services = [
    {
      id: 'testing',
      title: 'SI 개발 외주',
      subtitle: 'S/W\nDevelopment',
      route: '/development'
    },
    {
      id: 'geteyes',
      title: 'QA 서비스',
      subtitle: 'Testing\nService',
      route: '/testingservice'
    },
    {
      id: 'qmeet',
      title: 'QA 외주 플랫폼',
      subtitle: 'Q-Meet\nPlatform',
      route: '/qmeet'
    },
    {
      id: 'select',
      title: 'QA 아웃소싱 입찰 대행',
      subtitle: 'Q-Meet\nSelect',
      route: 'https://www.q-meet.com/select' // 외부 셀렉트(제안 대행) 서비스 페이지
    }
  ]

  const infoCards = [
    {
      id: 'recruit',
      title: 'L-Walk PICK',
      description: [
        '함께 성장하며 나아갈',
        '꿈과 열정있는 리드워커를 모집합니다.'
      ],
      route: '/recruit'
    },
    {
      id: 'contact',
      title: 'Contact us',
      description: [
        '질문이 있으신가요?',
        '친절히 답변 드리겠습니다'
      ],
      route: '/contactus',
      icon: require('@/assets/ic_008.png')
    }
  ]

  return {
    services,
    infoCards
  }
}
